export enum CatalogueItemEvent {
    UPDATED = 'catalogueItem:updated',
}

export interface CatalogueItemUpdatedPayload {
    item?: { id?: number };
}

export interface CatalogueItemEventMap {
    [CatalogueItemEvent.UPDATED]: CatalogueItemUpdatedPayload;
}
